/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApplicationSettingsResponse } from '../../models/application-settings-response';

export interface GetApiPublicApplicationSettings$Params {
  '_locale': 'de' | 'en' | 'fr';
}

export function getApiPublicApplicationSettings(http: HttpClient, rootUrl: string, params: GetApiPublicApplicationSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<ApplicationSettingsResponse>> {
  const rb = new RequestBuilder(rootUrl, getApiPublicApplicationSettings.PATH, 'get');
  if (params) {
    rb.path('_locale', params['_locale'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApplicationSettingsResponse>;
    })
  );
}

getApiPublicApplicationSettings.PATH = '/api/public/{_locale}/application_settings';
